import requestModule from '@/application/libs/requestModule'
import Util from  '@/application/libs/util'
import downloadFile from "js-file-download";

const _getCDFILIAL = () => Util.getFilterInSession().CDFILIAL;
const _getCDSERVFILI = () => Util.getFilterInSession().CDSERVFILI;
const _getIDTIPORESTRICAO = () => Util.getFilterInSession().TPCONTRATO;
const _getDTMESCARD = () => Util.getFilterInSession().DTMESCARD;
const _getIDUTRPADCA = () => Util.getFilterInSession().IDUTRPADCA;
const _getNRORG = () => Util.getLocalVar("userData").NRORG;


export default {

    /**
     * Return data from plates related with selected
     * service.
     * 
     * @returns {Promise}
     */
    verificaRelatorioIA(nrcenario, dataCatalog, regerar){
        return requestModule.postRequest('getData', {
            FROM: "VERIFICARELATORIO",
            PARAMS: { 
                NRCENARIOCARD: nrcenario,
                DATACATALOG: dataCatalog,
                REGERAR: regerar,
                NRORG: _getNRORG(),
            }
        }).then(response => response.dataset?.data);
    },
    updateRelatorio(nrcenario, relatorio){
        return requestModule.postRequest('getData', {
            FROM: "UPDATERELATORIO",
            PARAMS: { 
                NRCENARIOCARD: nrcenario,
                METADATAJSON: relatorio
            }
        }).then(response => response.dataset?.data);
    },
    getFeedbacks(nrcenario){
        return requestModule.postRequest('getData', {
            FROM: "FEEDBACKCARD",
            PARAMS: { 
                NRCENARIOCARD: nrcenario, 
             }
        }).then(response => response.dataset?.data);
    },
    getFeedbackPlates(nrfeedbackcard){
        return requestModule.postRequest('getData', {
            FROM: "FEEDBACKPRATO",
            PARAMS: {
                NRFEEDBACKCARD: nrfeedbackcard,
            }
        }).then(response => response.dataset?.data);

    },

    updateFeedback(feedbackData){
        return this.saveChangedData([feedbackData], 'FEEDBACKCARD');
    },
    deleteFeedback(nrfeedbackcard){
        return this.deleteData([{ NRFEEDBACKCARD: nrfeedbackcard, NRORG: _getNRORG() }], 'FEEDBACKCARD');
    },

    getPlatesParameters(){
        return requestModule.postRequest('getData', {
            FROM: "PARAMPRATO",
            PARAMS: {
                CDFILIAL: _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
                IDUTRPADCA: Util.getFilterInSession().IDUTRPADCA,
                CDNVPRATO: Util.getPlateNivel(),
                IDTIPORESTRICAO: Util.getFilterInSession().TPCONTRATO
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getGeneratedExcellFromPython() {
        return requestModule.postRequest('getReceitasAtivasExcell', {}, "Row", 1200000, { responseType: "blob", } ).then(response => {
            downloadFile(response, `base_receitas_ativas_teknisa_${new Date().getDate()}_${(new Date().getMonth()) + 1}_${new Date().getFullYear()}.xlsx`);
        });
    },

    getMainIngredient() {
        return requestModule.postRequest('getData', {
            FROM: "INGRPRINC",
            PARAMS: {}
        }).then(response=>response.dataset && response.dataset.data);
    },

    getDishesFromSearch(searchValue) {
        return requestModule.postRequest('getData', {
            FROM: "BUSCAPRATOS",
            PARAMS: {
                NMPRATO: searchValue,
                IDUTRPADCA: _getIDUTRPADCA(),
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    replicationProcedureCaller(replicationObject){
        return requestModule.postRequest('dishReplication', 
            {
                replicationObject: {
                    ...replicationObject,
                    CDOPERADOR: Util.getLocalVar('userData').CDOPERADOR,
                },
                NRORG: _getNRORG(),
            }
        ).then(response=>response.dataset && response.dataset.data);
    },

    exportPlatesProcedure(replicationObject){
        return requestModule.postRequest('exportPlatesProcedure', 
            {
                replicationObject: {
                    ...replicationObject,
                    CDOPERADOR: Util.getLocalVar('userData').CDOPERADOR,
                },
                NRORG: _getNRORG(),
            }
        ).then(response=>response.dataset && response.dataset.data);
    },

    getProteinType() {
        return requestModule.postRequest('getData', {
            FROM: "TPPROTEINA",
            PARAMS: {}
        }).then(response=>response.dataset && response.dataset.data);
    },

    getCutType() {
        return requestModule.postRequest('getData', {
            FROM: "TPCORTE",
            PARAMS: {}
        }).then(response=>response.dataset && response.dataset.data);
    },

    getPreparationMethod() {
        return requestModule.postRequest('getData', {
            FROM: "MDPREPARO",
            PARAMS: {}
        }).then(response=>response.dataset && response.dataset.data);
    },
    getCombinations() {
        return requestModule.postRequest('getData', {
            FROM: "COMBINACAOCARD",
            PARAMS: {
                CDFILIAL: _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
                IDTIPORESTRICAO: _getIDTIPORESTRICAO(),
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getPlates(userQuery = null, maxResults = 50) {
        return requestModule.postRequest('getData', {
            FROM: "PRATO",
            PARAMS: {
                CDFILIAL: _getCDFILIAL(),
                NMPRATO: null, 
                CDPRATO: null, 
                PRATO: userQuery, 
                MAX_RESULTS: maxResults 
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getCombPlates(userQuery = null, maxResults = 50) {
        return requestModule.postRequest('getData', {
            FROM: "COMB_PRATO",
            PARAMS: {
                CDFILIAL: _getCDFILIAL(),
                NMPRATO: null, 
                CDPRATO: null, 
                PRATO: userQuery, 
                MAX_RESULTS: maxResults 
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getPlateGroup(userQuery = null, maxResults = 50) {
        return requestModule.postRequest('getData', {
            FROM: "GRUPOTIPOPRATO_AUTOCOMPLETE",
            PARAMS: {
                GRUPOPRATO: userQuery, 
                MAX_RESULTS: maxResults 
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getPlatesWithGruop(userQuery = null, CDGRTIPOPR, maxResults = 50) {
        return requestModule.postRequest('getData', {
            FROM: "PRATO_GRUPO",
            PARAMS: {
                IDTIPORESTRICAO: _getIDTIPORESTRICAO(),
                CDFILIAL: _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
                PRATO: userQuery,
                MAX_RESULTS: maxResults,
                CDGRTIPOPR
            }
        }).then(response => response.dataset && response.dataset.data);
    },
    
    getPlateGroupForAutocomplete(userQuery = null, CDGRTIPOPR, maxResults = 50) {
        return requestModule.postRequest('getData', {
            FROM: "GRUPO_PRATO_AUTOCOMPLETE",
            PARAMS: {
                IDTIPORESTRICAO: _getIDTIPORESTRICAO(),
                CDFILIAL: _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
                GRUPOPRATO: userQuery,
                MAX_RESULTS: maxResults,
                CDGRTIPOPR
            }
        }).then(response => response.dataset && response.dataset.data);
    },

    getPlateTypeForAutocomplete(userQuery = null, CDGRTIPOPR, maxResults = 50) {
        return requestModule.postRequest('getData', {
            FROM: "TIPOPRATO_AUTOCOMPLETE",
            PARAMS: {
                TIPOPRAT: userQuery, 
                MAX_RESULTS: maxResults,
                CDGRTIPOPR
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getCombPlateGroup(userQuery = null, maxResults = 50) {
        return requestModule.postRequest('getData', {
            FROM: "COMB_GRUPOTIPOPRATO_AUTOCOMPLETE",
            PARAMS: {
                GRUPOPRATO: userQuery, 
                MAX_RESULTS: maxResults 
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getGroupPlates(){
        const {
            TPCONTRATO: IDTIPORESTRICAO,
            CDFILIAL, CDSERVFILI
        } = Util.getFilterInSession();
        return requestModule.postRequest('getData', {
            FROM: "GRUPOPRAT",
            PARAMS: { IDTIPORESTRICAO, CDFILIAL, CDSERVFILI }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getFilial(){
        return requestModule.postRequest('getData', {
            FROM: "FILIAL_ATRATIVIDADE",
            PARAMS: { 
                CDOPERADOR: Util.getLocalVar('userData').CDOPERADOR,
                CDFILIAL:  _getCDFILIAL()
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    /**
     * Return attractiveness from plates related with 
     * selected service.
     * 
     * @returns {Promise}
     */
    getAttractivenessGridData(){
        return requestModule.postRequest('getData', {
            FROM: "ATRATIVIDADE",
            PARAMS: {
                CDFILIAL:  _getCDFILIAL()
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getSimilarPlates(CDPRATO, NMPRATO){
        return requestModule.postRequest('getData', {
            FROM: "SIMILAR_PLATES",
            PARAMS: {
                CDFILIAL:  _getCDFILIAL(),
                CDPRATO,
                NMPRATO
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getConsumptionHistory(type){
        return requestModule.postRequest('getData', {
            FROM: "CONSUMPTION_HISTORY",
            PARAMS: {
                IDOPCAO: type,
                IDTIPORESTRICAO: _getIDTIPORESTRICAO(),
                CDFILIAL:  _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
                DTMESCARD: _getDTMESCARD()
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getPlatesConsumptionHistory(query){
        return requestModule.postRequest('getData', {
            FROM: "PRATO_HIST_CONSUMO",
            PARAMS: {
                CDFILIAL:  _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
                PRATO: query,
                MAX_RESULTS: 20
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getRestrictionRules(){
        return requestModule.postRequest('getData', {
            FROM: "REGRAS_RESTRICAO_REPETICAO",
            PARAMS: {
                CDFILIAL:  _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getExportPlatesGroups(){
        return requestModule.postRequest('getData', {
            FROM: "EXPORT_RESTRICTION",
            PARAMS: {
                CDFILIAL:  _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getPlateTypeByRestrictionRule(NRREGRARESTREPET){
        if(NRREGRARESTREPET) {
            return requestModule.postRequest('getData', {
                FROM: "TIPOPRATO_POR_REGRAS_RESTRICAO",
                PARAMS: {
                    NRREGRARESTREPET
                }
            }).then(response=>response.dataset && response.dataset.data);
        } else {
            return Promise.resolve([]);
        }
    },

    getIngredientsRestrictionRule(NRREGRARESTREPET){
        if(NRREGRARESTREPET) {
            return requestModule.postRequest('getData', {
                FROM: "INGREDIENTE_REGRAS_RESTRICAO",
                PARAMS: {
                    NRREGRARESTREPET
                }
            }).then(response=>response.dataset && response.dataset.data);
        } else {
            return Promise.resolve([]);
        }
    },

    getPlateTypeNotInRestrictionRule(query){
        return requestModule.postRequest('getData', {
            FROM: "TIPOPRATO_POR_REGRAS_RESTRICAO_AUTOCOMPLETE",
            PARAMS: {
                CDSERVFILI: _getCDSERVFILI(),
                CDFILIAL: _getCDFILIAL(),
                TIPOPRAT: query
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getIngredientsNotInRestrictionRule(query, NRREGRARESTREPET){
        return requestModule.postRequest('getData', {
            FROM: "INGREDIENTE_REGRAS_RESTRICAO_AUTOCOMPLETE",
            PARAMS: {
                NRREGRARESTREPET,
                NMINGREDIENTEPRINC: query
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getConsumptionHistoryInterval(){
        return requestModule.postRequest('getData', {
            FROM: "CONSUMPTION_HISTORY_INTERVAL",
            PARAMS: {
                CDFILIAL: _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI()
            }
        }).then((response) => {
            const rawData = response.dataset && response.dataset.data
            if(rawData.length > 0){
                const [row] = rawData
                return row.NRMESHISTCONS
            } else {
                throw response
            }
        })
    },

    saveChangedData(changedData, dataSourceName){
        return requestModule.postRequest('updateData', {
            FROM: dataSourceName,
            PARAMS: changedData,
        });
    },
    insertData(changedData, dataSourceName){
        return new Promise((resolve, reject) => {
            requestModule.postRequest('insertData', {
                FROM: dataSourceName,
                PARAMS: changedData,
            }).then(response => {
                if(!response.error){
                    resolve(response);
                } else {
                    throw response;
                }
            }).catch(e => {
                if(e.errorCode !== 0){
                    reject(e);
                } else {
                    reject({});
                }
            })
        });
    },

    deleteData(changedData, dataSourceName){
        return new Promise((resolve, reject) => {
            requestModule.postRequest('deleteData', {
                FROM: dataSourceName,
                PARAMS: changedData,
            }).then(response => {
                if(!response.error){
                    resolve(response);
                } else {
                    throw response;
                }
            }).catch(e => {
                if(e.errorCode !== 0){
                    reject(e);
                } else {
                    reject({});
                }
            })
        });
    },

    callProcedureExportCadOtimizador(FILISERV, TABLE, ITEMS, MODE, PLATEGRID) {
        return requestModule.postRequest('exportCadOtimizador', 
            {
                TABELA: TABLE,
                ITEM: ITEMS,
                FILISERV: FILISERV,
                MODO: MODE,
                PLATEGRID:PLATEGRID,
                CDFILIAL: _getCDFILIAL(),
                CDSERVFILI: _getCDSERVFILI(),
                CDOPERADOR: Util.getLocalVar('userData').CDOPERADOR,
                IDTIPORESTRICAO: _getIDTIPORESTRICAO(),
                NRORG: _getNRORG(),
            }
        ).then(response=>response.dataset);
    },

    callProcedureExportHistoryConsumption(FILISERV, TABLE, ITEMS, MODE) {
        return requestModule.postRequest('exportHistoryConsumption', 
            {
                TABELA: TABLE,
                ITEM: ITEMS,
                FILISERV: FILISERV,
                MODO: MODE,
                DTMESCARD: _getDTMESCARD(),
                CDFILIAL_ORIGEM: _getCDFILIAL(),
                CDSERVFILI_ORIGEM: _getCDSERVFILI(),
                CDOPERADOR: Util.getLocalVar('userData').CDOPERADOR,
                NRORG: _getNRORG(),
            }
        ).then(response=>response.dataset);
    },

    submitFile(data, tableName){
        data.IDUTRPADCA = _getIDUTRPADCA();
        data.CDOPERADOR = Util.getLocalVar("userData").CDOPERADOR;
        data.CDFILIAL = _getCDFILIAL();
        data.IDTIPORESTRICAO = _getIDTIPORESTRICAO();
        data.CDSERVFILI = _getCDSERVFILI();
        data.tableName = tableName;
        
        return new Promise((resolve, reject) => {
            requestModule.postRequest('submitFile', data,
            ).then(response => {
                if(!response.error){
                    resolve(response);
                } else {
                    throw response;
                }
            }).catch(e => {
                if (e && typeof e.errorCode !== 'undefined' && e.errorCode !== 0) {
                    reject(e);
                } else {
                    reject({});
                }
            });
        });
    },
};
